module.exports = __webpack_public_path__ + "static/media/directions_walk.8979d2f4.svg";